var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrinBeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 247.7c3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm93.4 73.1C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-5.3-1.7-11.1-.5-15.3 3.1-4.2 3.7-6.2 9.2-5.3 14.8 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c.9-5.5-1.1-11.1-5.3-14.8-4.3-3.7-10.2-4.9-15.5-3.1zM248 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C325 383.7 283 400 248 400zm0-392C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrinBeam);
export default __webpack_public_path__ + "static/media/grin-beam.4705c1cc02d3dc8029cdb38b0d3431a6.svg";
export { ForwardRef as ReactComponent };